import {
    FETCH_CATEGORY_MAPPING,
    FETCH_CATEGORY_MAPPING_SUCCESS,
    FETCH_CATEGORY_MAPPING_FAILURE,
    FETCH_CATEGORY_MAPPING_LIST,
    FETCH_CATEGORY_MAPPING_LIST_SUCCESS,
    FETCH_CATEGORY_MAPPING_LIST_FAILURE,
    SAVE_CATEGROY_MAPPING_REQUEST,
    SAVE_CATEGORY_MAPPING_SUCCESS,
    SAVE_CATEGORY_MAPPING_FAILURE
} from "./actionType";

// Fetch category mapping
export const fetchCategoryMapping = (catId, unitId) => ({
    type: FETCH_CATEGORY_MAPPING,
    payload: { catId, unitId }
});

export const fetchCategoryMappingSuccess = (data) => ({
    type: FETCH_CATEGORY_MAPPING_SUCCESS,
    payload: data,
});

export const fetchCategoryMappingFailure = (error) => ({
    type: FETCH_CATEGORY_MAPPING_FAILURE,
    payload: error,
});

export const fetchCategoriesMappinglist = (payload) => ({
    type: FETCH_CATEGORY_MAPPING_LIST,
    payload
});

export const fetchCategoriesMappinglistSuccess = (data) => ({
    type: FETCH_CATEGORY_MAPPING_LIST_SUCCESS,
    payload: data,
});

export const fetchCategoriesMappinglistgFailure = (error) => ({
    type: FETCH_CATEGORY_MAPPING_LIST_FAILURE,
    payload: error,
});

// Create categorymapping
export const createCategorymappingRequest = (formData, isEdit) => ({
    type: SAVE_CATEGROY_MAPPING_REQUEST,
    payload: { formData, isEdit },
});

export const createCategorymappingSuccess = (response) => ({
    type: SAVE_CATEGORY_MAPPING_SUCCESS,
    payload: response,
});

export const createCategorymappingFailure = (error) => ({
    type: SAVE_CATEGORY_MAPPING_FAILURE,
    payload: error,
});